export const VSP_100_MONTHLY = 100;
